/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    angular
        .module('enervee')
        .directive('addToCartButton', addToCartButtonDirective);

    /*
     Creates checkout add to cart button directive
     <add-to-cart-button></add-to-cart-button>
     */

    function addToCartButtonDirective() {
        return {
            restrict: 'E',
            scope: {
                product: '='
            },
            template: require('@app/shared/integrations/enerveeCheckout/addToCartButton/addToCartButtonView.html'),
            controller: addToCartButtonController
        };
    }

    addToCartButtonController.$inject = [
        '$log',
        '$scope',
        'CartAnalyticsService',
        'CmsContentService',
        'EnerveeCheckoutService',
        'UtilService'
    ];
    function addToCartButtonController(
        $log,
        $scope,
        CartAnalyticsService,
        CmsContentService,
        EnerveeCheckoutService,
        UtilService
    ) {
        $scope.isCheckoutEnabled = UtilService.isFeatureEnabled('checkout_enabled') && UtilService.isFeatureEnabled('product_card_checkout_button');
        CmsContentService.getMarketPlaceText('checkout:add_to_cart', {}, $scope.product.category.id).then(function (text) {
            $scope.addToCartText = text;
        });
        CmsContentService.getMarketPlaceText('checkout:out_of_stock', {}, $scope.product.category.id).then(function (text) {
            $scope.outOfStockText = text;
        });

        /**
         * Adds the product to the cart.
         * Used on cardnoveauView.html
         *
         * @param {Event} event
         * @param {Object} product
         */
        $scope.addProductToCart = function (event, product) {
            event.stopPropagation();
            event.preventDefault();

            if ($scope.isCheckoutEnabled && product.checkoutInStock) {
                EnerveeCheckoutService.addProductToCart(product.id, 1).then(function success() {
                    CartAnalyticsService.reportEvent('Cart Engaged', {
                        location: 'mainContent',
                        type_of_change: 'Add Product',
                    });
                }, function error(error) {
                    $log.warn('Enervee Checkout Error: ' + error);
                });
            }
        };
    }
})(angular);